import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";

import "../../Config/loading.css";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Sales() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [projectsData, setProjectsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const { setID } = useLabelContext();

  useEffect(() => {
    const MisUserDetails =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (!MisUserDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}project/GetProjects`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data.ResultData);

        if (data.Status) {
          setProjectsData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setProjectsData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // const filteredItems = projectsData.filter(
  //   (item) =>
  //     (item.name &&
  //       item.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.units &&
  //       item.units.toLowerCase().includes(searchTerm.toLowerCase()))
  // );

  const filteredItems = useMemo(() => {
    const results = projectsData.filter(
      (item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.units &&
          item.units.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    setCurrentPage(1);

    return results;
  }, [projectsData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <Base>
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title ">
            <h4>Products</h4>
            <h6>Manage your Products</h6>
          </div>
        </div>
      </div>

      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <input
                  type="text"
                  name="search"
                  placeholder="Search..."
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="table-responsive ">
            <table className="table dataew">
              <thead>
                <tr>
                  <th className="no-sort">
                    <label className="checkboxs">
                      <input type="checkbox" id="select-all" />
                      <span className="checkmarks"></span>
                    </label>
                  </th>
                  <th>Customer Name</th>
                  <th>Order No</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Discount</th>
                  <th>Total </th>
                  <th className="no-sort">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <td colSpan={12} className="etxt-center">
                    <p className="text-center">
                      <div className="containers m-auto">
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                      </div>
                    </p>
                  </td>
                ) : (
                  currentItems &&
                  currentItems.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks"></span>
                        </label>
                      </td>
                      <td>{item.name}</td>

                      <td>{item.project_cost}</td>
                      <td>{formatDate(item.start_date)}</td>
                      <td>{formatDate(item.deadline)}</td>
                      <td>{item.notes}</td>
                      <td>
                        {item.status === 1 ? (
                          <span className="badge bg-outline-success">
                            Active
                          </span>
                        ) : (
                          <span className="badge bg-outline-danger">
                            Inactive
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={projectsData.length}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>
      </div>

      <Footer></Footer>
    </Base>
  );
}
